import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import Keycloak from 'keycloak-js';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';

interface NavItem {
  label: string;
  icon: string;
  routerLink?: string;
  disabled?: boolean;
}

interface NavSection {
  label: string;
  icon: string;
  expanded: ReturnType<typeof signal<boolean>>;
  items: NavItem[];
}

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, RouterLink, RouterLinkActive, ButtonModule, ToolbarModule],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss',
})
export class AppLayoutComponent {
  private readonly keycloak = inject(Keycloak);

  readonly username = computed(() => {
    const token = this.keycloak.tokenParsed as any;
    return token?.name ?? token?.preferred_username ?? '';
  });

  readonly sections: NavSection[] = [
    {
      label: 'Endkunden',
      icon: 'pi pi-users',
      expanded: signal(false),
      items: [
        { label: 'Anzeige & Export', icon: 'pi pi-table', routerLink: '/endkunden/liste' },
        { label: 'Import', icon: 'pi pi-upload', routerLink: '/endkunden/import' },
      ],
    },
    {
      label: 'Artikel',
      icon: 'pi pi-book',
      expanded: signal(false),
      items: [
        { label: 'Anzeige & Export', icon: 'pi pi-table', routerLink: '/artikel/liste' },
        { label: 'Import', icon: 'pi pi-upload', routerLink: '/artikel/import' },
        { label: 'Preisaktualisierungen', icon: 'pi pi-tag', routerLink: '/artikel/preisaktualisierungen' },
      ],
    },
    {
      label: 'Artikelbewegungen',
      icon: 'pi pi-arrow-right-arrow-left',
      expanded: signal(false),
      items: [
        { label: 'Anzeige & Export', icon: 'pi pi-table', routerLink: '/artikelbewegungen/liste' },
      ],
    },
    {
      label: 'Bestände',
      icon: 'pi pi-warehouse',
      expanded: signal(false),
      items: [
        { label: 'Reservierungen', icon: 'pi pi-bookmark', routerLink: '/bestaende/reservierungen' },
        { label: 'Bestandsliste',  icon: 'pi pi-list',     disabled: true },
      ],
    },
  ];

  toggle(section: NavSection): void {
    section.expanded.update((v) => !v);
  }

  logout(): void {
    this.keycloak.logout({ redirectUri: window.location.origin });
  }
}
